import React from "react";

import { Redirect, Link } from "react-router-dom";

// IMPORT MATERIAL-UI Components
import { Typography, Backdrop, CircularProgress, Box } from "@material-ui/core";

// import Backdrop from "@material-ui/core/Backdrop";
// import CircularProgress from "@material-ui/core/CircularProgress";
// import Box from "@material-ui/core/Box";

import Button from "@material-ui/core/Button";

import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogTitle from "@material-ui/core/DialogTitle";

import { TableSubmitMerged } from "../submit-datasets/TableSubmitMerged";
import SubmissionDialog from "../submit-datasets/SubmissionDialog";
import ErrorDialog from "../components/ErrorDialog";
import PopupError from "../components/PopupError";
import { Submission } from "../Submission";
import auth from "../../../Auth";
import findErrors from "../components/helper";
import { dataset_list, fileSubmissionCols } from "../../../apis";

const { config } = window;

// TODO
// Show an error message if the user wants to submit a file
// to a project in which no dataset has been created yet

// The error box should be a dialog box
// which has a button which allows the redirect to the dataset submission page

// it needs
// an API which get the list of datasets for a given project

const initFormControls = (headersCfg) => {
  const formControls = [];
  headersCfg.forEach((header) => {
    formControls.push({ id: header.id, index: 0, value: "", error: "" });
  });
  return [formControls];
};

const getSubmissionCols = async () => {
  let jsonData = {};

  const response = await fileSubmissionCols(
    auth.getToken(),
    config.api_endpoint
  );

  if (response.status === 200) {
    jsonData = await response.json();
    return jsonData[0].message;
  }
  return [];
};

/**
 * Component for uploading files.
 * @category Category
 * @subcategory Submission
 * @component
 */
export class SubmitFiles extends Submission {
  constructor(props) {
    super(props);

    this.state = {
      numberRows: 1,
      headers: [],
      formControls: [],

      // no longer needed?
      groups: { value: "Please select", selection: [], error: "" },

      redirect: false,
      showError: false,
      redirectContents: [[]],
      popupErrors: "",
      csvFileName: "",
      fileObjects: [],
      uploading: false,
      rowsSubmitted: 0,
      filledRows: 0,
      selectedFiles: {},
      filesUploaded: [],
      projectId: this.props.location.projectId,
      validated: false,
    };
    this.populateFormData = this.populateFormData.bind(this);
    this.createSummaryInserted = this.createSummaryInserted.bind(this);
  }

  async componentDidMount() {
    // initialize a table with 10 rows
    const tableHeaders = await getSubmissionCols();
    
    const response = await dataset_list(
      auth.getToken(),
      config.api_endpoint,
      JSON.stringify({ project_id: this.state.projectId, dataset_id: "" })
    );
    const data = response.status;

    if (data === 404) {
      this.setState({ showError: true });
      return;
    }

    this.setState({
      headers: tableHeaders,
      formControls: initFormControls(tableHeaders),
    });
    this.initComponent();
  }

  loadDatasets = async (search, loadedOptions, { page }) => {
    // https://codesandbox.io/s/5y2xq39v5k?file=/src/loadOptions.js:124-229

    /*Call API Endpoint*/
    //TODO replace with project+arg
    const response = await dataset_list(
      auth.getToken(),
      config.api_endpoint,
      JSON.stringify({ project_id: this.state.projectId, dataset_id: search })
    );
    const data = await response.json();

    const options = [];
    for (const [i, e] of data.entries()) {
      options.push({ value: i, label: e });
    }

    // react-select-async-paginate library expects loadedOptions
    const hasMore = false;
    loadedOptions = {
      options,
      hasMore,
      additional: {
        page,
      },
    };
    return loadedOptions;
  };

  validateSuffix = (fileName, valid_suffixes) => {
    const splitted = fileName.split(".");
    if (
      !(
        splitted.length === 1 ||
        (splitted[0] === "" && splitted.length === 2)
      ) &&
      valid_suffixes.includes(`.${splitted.pop().toLowerCase()}`)
    ) {
      return "";
    }
    return (
      "File suffix not recognised. It must be one of the following: " +
      valid_suffixes
    );
  };

  getNonEmptyRowIds = (formControls) => {
    const nonEmptyRows = [];

    for (const [i, row] of formControls.entries()) {
      let nonEmptyColsBool = false;
      for (const col of row) {
        if (!col.hasOwnProperty("value")) {
          continue;
        }

        if (Array.isArray) {
          if (col.value.length > 0) {
            nonEmptyColsBool = true;
          }
          continue;
        }

        if (col.value !== "") {
          nonEmptyColsBool = true;
          break;
        }
      }
      if (nonEmptyColsBool) {
        nonEmptyRows.push(i);
      }
    }

    return nonEmptyRows;
  };

  validateFileForm(formRows, nonEmptyRowIds) {
    const datasetsToFiles = {};
    for (const rowId of nonEmptyRowIds) {
      const row = formRows[rowId];

      // const colErrors = [];
      for (const col of row) {
        // 1. check if there are any mandatory fields empty
        const columnHeader = this.state.headers.find(
          (item) => item.id === col.id
        );
        const { value } = col;
        const errorMsg = "This field is required";
        col.error = "";
        if (columnHeader.mandatory) {
          if (!Array.isArray(value) && value === "") {
            col.error = errorMsg;
          }

          if (Array.isArray(value) && value.length === 0) {
            col.error = errorMsg;
          }
        }

        // 2. check if the file is valid
        if (col.id === "file") {
          const fileName = row.filter((col) => col.id === "file")[0].value[0];

          // 2.1 check if file suffix is valid
          col.error =
            fileName !== undefined
              ? this.validateSuffix(fileName, config.valid_suffixes)
              : errorMsg;

          const datasetID = row.filter((col) => col.id === "DatasetID")[0]
            .value;

          // 2.2 check two datasets ids have the same file name
          if (!(datasetID in datasetsToFiles)) datasetsToFiles[datasetID] = [];

          if (datasetsToFiles[datasetID].includes(fileName)) {
            col.error = "File name already assigned";
          } else {
            datasetsToFiles[datasetID].push(fileName);
          }
        }
        // if (col.error !== "") {
        //   colErrors.push(col.error);
        // }
      }
    }
  }

  validate = () => {
    // debugger;

    const formControls = [...this.state.formControls];
    const nonEmptyRowIds = this.getNonEmptyRowIds(formControls);

    // TODO
    // integrate below into validateForm
    // early exit if all rows are empty
    if (nonEmptyRowIds.length === 0) {
      this.setState({ formControls, validated: false });
      return;
    }

    this.validateFileForm(formControls, nonEmptyRowIds);

    this.setState({ formControls, validated: true });
    return formControls;
  };

  // validate = async () => {

  // TODO
  // only allow filenames w/o spaces

  // reference of the component for nested functions
  // const self = this;

  //Get current form control to later modify it

  //check if all rows are empty:
  // formControls.flat();

  // if (formControls.flat().filter((col) => col.value != "").length === 0) {
  //   this.setState({ formControls, validated: false });
  //   return null;
  // }

  // filter out the rows that are completely empty
  // const formRows = [];

  // FIXME
  // the function for nonEmptyRows is not working

  // wait till the getNonEmptyRows function is finished

  // const nonEmptyRows = [];
  // formControls.forEach((row, i) => {
  //   if (row.filter((col) => col.value != "").length > 0) {
  //
  //     nonEmptyRows.push(i);
  //     // formRows.push(formControls[i])
  //   }
  // });

  // return for each row what columns are empty

  // TODO
  // put below in a function

  //   const datasetsToFiles = {};
  //
  //   for (const rowId of nonEmptyRows) {
  //     const row = formControls[rowId];

  //     const colErrors = [];
  //     for (const col of row) {
  //       // 1. check if there are any mandatory fields empty
  //       const columnHeader = this.state.headers.find(
  //         (item) => item.id === col.id
  //       );
  //       const { value } = col;
  //       const errorMsg = "This field is required";
  //       col.error = "";
  //       if (columnHeader.mandatory) {
  //         if (!Array.isArray(value) && value === "") {
  //           col.error = errorMsg;
  //         }

  //         if (Array.isArray(value) && value.length === 0) {
  //           col.error = errorMsg;
  //         }
  //       }

  //       // 2. check if the file is valid
  //       if (col.id === "File") {
  //         // FIXME
  //         // function seem to be called twice
  //         // 1. render fileName == <file name>
  //         // 2. render fileName == undefined

  //         const fileName = row.filter((col) => col.id === "File")[0].value[0];
  //

  //         // 2.1 check if file suffix is valid
  //         col.error =
  //           fileName !== undefined
  //             ? this.validateSuffix(fileName, config.valid_suffixes)
  //             : errorMsg;

  //         const datasetID = row.filter((col) => col.id === "DatasetID")[0]
  //           .value;

  //         // 2.2 check two datasets ids have the same file name
  //         if (!(datasetID in datasetsToFiles)) datasetsToFiles[datasetID] = [];

  //         if (datasetsToFiles[datasetID].includes(fileName)) {
  //           col.error = "File name already assigned";
  //         } else {
  //           datasetsToFiles[datasetID].push(fileName);
  //         }
  //       }
  //       if (col.error !== "") {
  //         colErrors.push(col.error);
  //       }
  //     }
  //     if (colErrors.length > 0) {
  //
  //       this.setState({ formControls, validated: true });
  //       return formControls;
  //     }
  //   }
  //   this.setState({ formControls, validated: true });
  //   return formControls;
  // };

  populateFormData = (formData, fileData, metaData) => {
    fileData.forEach((fileObj) => {
      formData.append("file", fileObj);
    });
    formData.append("metaData", JSON.stringify(metaData));
    return formData;
  };

  handleUploadedFilesChanged = (fileChanged) => {
    this.setState((prevState) => ({
      filesUploaded: [...prevState.filesUploaded, fileChanged],
    }));

    // compare if all files are the same length as this.state.filesUploaded
    // if they are, then we can assume that all files are uploaded correctly
    // --> redirect to submission page
    if (this.state.selectedFiles.length === this.state.filesUploaded.length) {
      // set state uploading to false
      this.setLoadingState(false);
      this.createSummaryInserted(this.state.formControls);
    }
  };

  createSummaryInserted = (formRows) => {
    const tableContents = [];

    const tableHeaders = [];
    for (let row of this.state.headers) {
      tableHeaders.push(row.title);
    }
    tableContents.push(tableHeaders);

    // add table values
    for (let row of formRows) {
      const rowValues = [];
      let fileList = [];
      let index = 0;
      let fileIndex;
      let fileNameIndex = 0;

      // process all columns from rows
      for (let col of row) {
        if (col.id === "file") {
          rowValues.push("");
          // let files = col.value.split(" ");
          fileList = col.value;
          fileNameIndex = index;
        } else {
          rowValues.push(col.value);
        }
        index += 1;
      }

      // unfold columns
      for (let fileRow of fileList) {
        const insertRow = [...rowValues];
        insertRow[fileIndex] = fileRow;
        insertRow[fileNameIndex] = fileRow;
        tableContents.push(insertRow);
      }
    }
    // go to summary inserted
    const today = new Date().toISOString().slice(0, 10);

    this.setState({
      redirect: true,
      redirectContents: tableContents,
      csvFileName: `${today}_submitted_files.csv`,
    });
  };

  setSelectedFiles = (selectedFiles) => {
    this.setState({ selectedFiles });
  };

  setLoadingState = (bool) => {
    this.setState({ uploading: bool });
  };

  changeHandlerFiles = (files, rowId) => {
    // TODO
    // merge it with the changeHandler (in Submission.js)

    const rowControls = [...this.state.formControls[rowId]];
    
    const fieldControl = rowControls.find((item) => item.id === "file");
    fieldControl.value = files;

    const formControls = this.state.formControls.map((item, j) =>
      j === rowId ? rowControls : item
    );

    this.setState({
      formControls,
      selectedFiles: {},
    });
  };

  // on Change Handler for Dataset ID Selection
  changeSelectExperiment = (newValue, actionMeta) => {
    const [col_id, row_index] = actionMeta.name.split("-");

    // Update State With Selected Value
    const formControls = [...this.state.formControls];
    const fieldControl = formControls[row_index].find(
      (item) => item.id === col_id
    );
    fieldControl.valueIndex = newValue;
    fieldControl.value = newValue.label;
    this.setState(formControls);
  };

  closeModal = () => {
    if (this.state.popupErrors === "Session expired. Please login again") {
      auth.user.keycloak.logout();
    }
    this.setState({
      popupErrors: "",
      uploading: false,
    });
  };

  verifyDatasetId = async (value, projectId) => {
    // needed for filling the file upload table
    // using file_template.tsv

    // TODO
    // add a test to make sure that verifyDatasetId
    // works with different project_ids

    if (value !== "") {
      const response = await dataset_list(
        auth.getToken(),
        config.api_endpoint,
        JSON.stringify({ dataset_id: "", project_id: projectId })
      );
      const data = await response.json();

      if (data.includes(value)) {
        return true;
      }
    }
  };

  // overwrite loadFile from Submission.js
  // because we need this.props.location.projectId
  loadFile = async (data) => {
    //* only accepts TSV files

    //TODO
    //check if file is TSV
    //if not TSV return error

    //Reset Forms
    this.resetStateForms();
    //Update Load Data to True
    this.setState({ loadData: true });
    //Get current form control to later modify it
    const formControls = [...this.state.formControls];
    //Loop Over all Data
    let isFirst = true;
    let rowNumber = 0;
    let headerTitles = [];

    for (const row of data) {
      //1. Avoid LogoutButton
      if (isFirst) {
        isFirst = false;
        headerTitles = row;
      } else {
        //Check if Form Controls has an array to fulfill it or not
        if (rowNumber >= formControls.length) {
          //Generate new item
          this.addRows(1, formControls);
        }
        let colNumber = 0;
        for (const column of row) {
          // TODO
          // better rename the variable column to value

          // TODO
          // update the selection columns based on the values in the template

          //Update value
          try {
            const { inputType, selection } = this.state.headers.filter(
              (item) => item.title === headerTitles[colNumber]
            )[0];

            const correctedColNumber = this.state.headers.findIndex(
              (item) => item.title === headerTitles[colNumber]
            );

            // const { inputType } = this.state.headers.filter(
            //   (item) => item.title === headerTitles[colNumber]
            // )[0];

            if (
              Array.isArray(formControls[rowNumber][correctedColNumber].value)
            ) {
              formControls[rowNumber][correctedColNumber].value.push(column);
            } else if (
              // only trigger if dataset id (used for file upload)
              formControls[rowNumber][correctedColNumber].id === "DatasetID"
            ) {
              /*Call API Endpoint*/
              const datasetIdIsValid = await this.verifyDatasetId(
                column,
                this.props.location.projectId
              );
              if (datasetIdIsValid) {
                formControls[rowNumber][colNumber].value = column;
                formControls[rowNumber][colNumber].valueIndex = {
                  value: 0,
                  label: column,
                };
                formControls[rowNumber][colNumber].error = "";
              }
            } else if (inputType === "select") {
              let input = column;
              if (column === "true") {
                input = true;
              } else if (column === "false") {
                input = false;
              }

              formControls[rowNumber][colNumber].value = input;
              formControls[rowNumber][colNumber].valueIndex = {
                value: 0,
                label: input,
              };
              formControls[rowNumber][colNumber].error = "";
            } else {
              formControls[rowNumber][correctedColNumber].value = column;
            }
            colNumber++;
          } catch (error) {
            // TODO
            // show error message
            // => "not all columns were filled please review the template"
            //    "or fill the missing columns manually"
          }
        }
        rowNumber++;
      }
    }
    this.validateForm(this.getFilledRows(formControls));

    //Update Form Control State
    this.setState({
      formControls: formControls,
      numberRows: formControls.length,
      loadData: false,
    });
  };

  render() {
    const excelTemplate = "file";
    const ERRORS = findErrors(this.state.formControls);

    if (!this.props.location.projectId) {
      return <Redirect to="uploadfiles/selectproject" />;
    }

    // Show popup in case an error with the api post occurs
    if (this.state.popupErrors) {
      return (
        <PopupError
          error={this.state.popupErrors}
          onClose={() => this.closeModal()}
        />
      );
    }

    if (this.state.showError) {
      // show a dialogbox with the error
      return (
        <Dialog
          open={this.state.showError}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
        >
          <DialogTitle id="alert-dialog-title">
            {"This project has no datasets yet"}
          </DialogTitle>
          <DialogActions>
            <Button
              component={Link}
              to={{
                pathname: "/submitdatasets",
                projectId: this.state.projectId,
              }}
              color="primary"
              autoFocus
            >
              {"Create a new dataset"}
            </Button>
          </DialogActions>
        </Dialog>
      );
    }

    return (
      <div className={"mainContent"}>
        {this.state.redirect ? (
          <SubmissionDialog
            type={"Files"}
            onClose={() => this.setState({ redirect: false })}
            tableContents={this.state.redirectContents}
            filename={this.state.csvFileName}
            projectId={this.props.location.projectId}
            open={this.state.redirect}
          />
        ) : null}
        {this.state.validated ? (
          <ErrorDialog
            onClose={() => this.setState({ validated: false })}
            errors={ERRORS}
          />
        ) : null}
        <Typography variant={"h5"} align={"center"}>
          project: {this.props.location.projectId}{" "}
        </Typography>
        <Typography variant={"h5"} align={"center"}>
          {" "}
          Upload file/s{" "}
        </Typography>

        {/* TODO */}
        {/* pass the project_id to TableSubmitMerged */}

        <TableSubmitMerged
          hasErrors={this.hasErrors}
          addRow={this.addRow}
          validate={this.validate}
          reload={this.reload}
          loadFile={this.loadFile}
          getExcel={() => this.getExcel(excelTemplate)}
          // no longer needed?
          // groups={this.state.groups}

          headers={this.state.headers}
          contents={this.state.formControls}
          changeHandler={this.changeHandler}
          changeHandlerFiles={this.changeHandlerFiles}
          loadDatasets={this.loadDatasets}
          changeSelectExperiment={this.changeSelectExperiment}
          createSummaryInserted={this.createSummaryInserted}
          handleUploadedFilesChanged={this.handleUploadedFilesChanged}
          setSelectedFiles={this.setSelectedFiles}
          setLoadingState={this.setLoadingState}
          projectId={this.props.location.projectId}
        />

        {/* <ActionTableSubmit
          submit={this.submit}
          addRow={this.addRow}
          validate={this.validate}
          reload={this.reload}
          loadFile={this.loadFile}
          getExcel={() => this.getExcel(excelTemplate)}
          groups={this.state.groups}
        />
        <TableSubmit
          headers={this.state.headers}
          contents={this.state.formControls}
          changeHandler={this.changeHandlerFiles}
          loadDatasets={this.loadDatasets}
          changeSelectExperiment={this.changeSelectExperiment}
        /> */}

        {/* TODO */}
        {/* this conditional render needs a tests */}

        <Backdrop
          style={{ color: "white", zIndex: "100" }}
          open={this.state.uploading && ERRORS === 0}
        >
          <CircularProgress color="inherit" />
          <Box>
            <Typography variant="h6" align="center">
              Uploading files... (closing the window will cancel the upload)
            </Typography>
            {`Files uploaded:${this.state.filesUploaded.length}/${this.state.selectedFiles.length}`}
          </Box>
        </Backdrop>
      </div>
    );
  }
}
